import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { alert } from "../../../Utils/toast";
import axios from "../../../Utils/axiosConfig";
import {getDeviceName, getDevicePlatform} from "../../../Utils/device";

export type FcmToken = {
  status?: number;
  message: string;
  data: {
    data: { text: string };
  };
};

export type FcmTokenLoadAction = {
  type: string;
  payload: { fcmToken?: string };
};

export const FcmToken = new ReduxFetchState<
  FcmToken["data"],
  { fcmToken?: string },
  any
>("fcmToken");

export function* watchFcmToken(action: FcmTokenLoadAction) {
  const device_platform = getDevicePlatform();
  const device_name = getDeviceName();
  try {

    const { data, message }: FcmToken = yield axios({
      url: "/api/v1/users/device/register",
      method: "POST",
      data: { fcm_token: action.payload.fcmToken,device_platform,device_name },
    });
    yield put(FcmToken.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {

    alert({ type: "error", message: e.response?.data?.message });
    yield put(FcmToken.actions.loadFailure(e.message));
  }
}

export function* fcmTokenSagas() {
  yield takeEvery(FcmToken.actionTypes.load, watchFcmToken);
}

export function useFcmToken() {
  const { loading, data, ...fcmTokenState } = useAppSelector(
    (state) => state.fcmToken,
  );
  const dispatch = useAppDispatch();

  const dispatchFcmToken = useCallback(
    (data: { fcmToken: string }) => {
      dispatch(FcmToken.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...fcmTokenState,
    dispatchFcmToken,
    fcmTokenLoading: loading,
    fcmTokenData: data,
  };
}

export const {
  actionTypes: fcmTokenActionsTypes,
  actions: fcmTokenActions,
  reducer: fcmTokenReducer,
} = FcmToken;